module.exports = __webpack_public_path__ + "media/images/voice30-2-82220f00aa2be99510eba3663c6f67c9.jpg";